import React from "react";
import { Button } from "panamera-react-ui";
var css = {
  "container": "oalp-3WkzD",
  "bannerContainer": "oalp-30Wqw",
  "image": "oalp-2v93G",
  "showAllContainer": "oalp-339ee",
  "showAllBtn": "oalp-Ngd8S"
};
import classnames from "classnames";
import { compose } from "redux";
import { withRouter } from "../../Helpers/withRouter";
import { fileNames } from "../../Constants/imageUrls";
import { FormattedMessage as Translation } from "react-intl";
export var EmptyCarComponent = function EmptyCarComponent(_ref) {
  var onclick = _ref.onclick,
    isMobile = _ref.isMobile,
    isOlxMobbi = _ref.isOlxMobbi,
    url = _ref.url,
    router = _ref.router,
    bannerType = _ref.bannerType,
    dataAutIdImage = _ref.dataAutIdImage,
    dataAutIdButton = _ref.dataAutIdButton;
  var clickHandler = function clickHandler() {
    if (router !== null) {
      router === null || router === void 0 ? void 0 : router.push(isOlxMobbi ? "/olxmobbi".concat(url) : url);
    }
  };
  var getImage = function getImage() {
    var imageUrl = fileNames.BANNER_EMPTY_DISCOUNT_CAR_DESKTOP;
    switch (bannerType) {
      case "discount_car":
        if (isMobile) {
          imageUrl = fileNames.BANNER_EMPTY_DISCOUNT_CAR_MOBILE;
          return imageUrl;
        }
        return imageUrl;
      case "recent_activity":
        imageUrl = fileNames.BANNER_EMPTY_RECENTLY_VIEW_DESKTOP;
        if (isMobile) {
          imageUrl = fileNames.BANNER_EMPTY_RECENTLY_VIEW_MOBILE;
          return imageUrl;
        }
        return imageUrl;
      default:
        return imageUrl;
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(css.container)
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(css.bannerContainer)
  }, /*#__PURE__*/React.createElement("img", {
    className: classnames(css.image),
    src: getImage(),
    "data-aut-id": dataAutIdImage
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames(css.showAllContainer)
  }, /*#__PURE__*/React.createElement(Button, {
    type: "secondaryBtn",
    onClick: isMobile ? clickHandler : onclick,
    className: classnames(css.showAllBtn),
    "data-aut-id": dataAutIdButton
  }, isMobile ? /*#__PURE__*/React.createElement(Translation, {
    id: "showCars"
  }) : /*#__PURE__*/React.createElement(Translation, {
    id: "showAllCars"
  }))));
};
export default compose(withRouter)(EmptyCarComponent);